import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import { GROWTH_TASK_INVENTORY_BY_PLANT_QUERY } from "@/graphql/inventory.js";

const state = {
    inventory: []
};

const getters = {};

const mutations = {
    [types.SET_GROWTH_TASK_INVENTORY_BY_PLANT](state, inventory) {
        state.inventory = inventory;
    }
};

const actions = {
    async fetchGrowthTaskInventoryByPlant(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GROWTH_TASK_INVENTORY_BY_PLANT_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    // console.log(response);
                    const inventory =
                        response.data.tenantGrowthTaskInventoryByPlants.edges;

                    // set
                    context.commit(
                        types.SET_GROWTH_TASK_INVENTORY_BY_PLANT,
                        inventory
                    );

                    resolve(inventory);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
